import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import Player from '@vimeo/player';
import * as streamActions from '../../actions/streamActions';

class VimeoStream extends Component {
  constructor(props) {
    super(props);
    this.state = {
      player: null,
      duration: 0,
      percent: 0,
    };
  }

  componentDidMount() {
    this.createPlayer();
  }

  componentWillReceiveProps(nextProps) {
    // For when swapping videos when the user navigates a session
    if (this.props.streamId !== nextProps.streamId) {
      this.loadNewVideo(nextProps.streamId);
    }
  }

  getVideoDuration = async () => {
    const { player } = this.state;
    // The Vimeo JS API getDuration function returns a Promise
    const durationPromise = player.getDuration();
    const duration = await durationPromise;
    return duration;
  }

  setVideoDuration = () => {
    this.getVideoDuration().then((duration) => {
      this.setState({ duration });
    });
  }

  resetTrackingPercentage = () => {
    this.setState({ percent: 0 });
  }

  loadNewVideo = (newStreamId) => {
    this.state.player.loadVideo(newStreamId).then(() => {
      this.setVideoDuration();
      this.resetTrackingPercentage();
    });
  }

  createPlayer = () => {
    const { streamId, title } = this.props;
    const options = { id: Number(streamId), title };
    this.setState({ player: new Player(streamId, options) }, () => {
      this.setVideoDuration();
      this.addEventListeners();
    });
  }

  addEventListeners = () => {
    const { player } = this.state;
    player.on('play', e => this.handleVideoPlay(e));
    player.on('ended', () => this.handleVideoEnd());
    player.on('timeupdate', e => this.handleTimeUpdate(e));
  }

  handleVideoPlay = (e) => {
    // Only want to trigger the tracking API on the initial play event
    if (e.seconds === 0) {
      this.props.actions.trackStream({ stream_id: this.props.streamId, action: 'play' });
    }
  }

  handleVideoEnd = () => {
    this.props.actions.trackStream({ stream_id: this.props.streamId, action: 'ended' });
  }

  handleTimeUpdate = (e) => {
    // The Vimeo timeupdate function returns percentage as a decimal between 0-1. We want to fire a function every time the user gets another 10% through the video
    const interval = 0.1;
    const nextPercentage = this.state.percent + interval;

    if (e.percent >= nextPercentage) {
      this.props.actions.trackStream({
        stream_id: this.props.streamId,
        action: 'progress',
        data: {
          percent: nextPercentage,
          seconds: e.seconds,
        },
      });
      this.setState({ percent: nextPercentage });
    }
  }

  render() {
    return (
      <div className="ratio-16-9" id={this.props.streamId} />
    );
  }
}

VimeoStream.propTypes = {
  streamId: PropTypes.string.isRequired,
  title: PropTypes.string,
  actions: PropTypes.object.isRequired,
};

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(Object.assign({}, streamActions), dispatch),
  };
}

export default connect(null, mapDispatchToProps)(VimeoStream);



// WEBPACK FOOTER //
// ./library/app/components/Content/VimeoStream.js